// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2fIpW","overflowing":"ReadFullNote_overflowing__3B5Uk"};